export const transformStatusLabel = (status: string) => {
  if (status === "FINISHED") return "Selesai";
  else if (status === "CREATED") return "Menunggu pembayaran";
  else if (status === "PROCESSED") return "Sedang diproses";
  else if (status === "FAILED") return "Tahap proses lanjut";
  return "-";
};
